import {
  Button,
  TextField,
  Card,
  Box,
  Divider,
  Typography,
  Grid,
  Alert,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
  Fade,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
} from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import { useTheme } from '@mui/material/styles'
import OutlinedInput from '@mui/material/OutlinedInput'
import React, { useState, useEffect } from 'react'
import Proposal from '../../../Proposal'
import bigInt from 'big-integer'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'
import Vote from './Vote'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { ToastContainer, toast } from 'react-toastify'
import Backdrop from '@mui/material/Backdrop'
import './Voting.css'
import { ethers } from 'ethers'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '720px',
  bgcolor: '#2C2E3F',
  borderRadius: '24px',
  p: 2,
  minWidth: '320px',
}

const columns = [
  { id: 'sno', label: 'S No.', minWidth: 50 },
  { id: 'name', label: 'Name', minWidth: 50 },
  { id: 'value', label: 'Value', minWidth: 50 },
  { id: 'details', label: 'Detail', minWidth: 50 },
  { id: 'info', label: 'More Info', minWidth: 50 },
]

export default function MyProposal() {
  useEffect(() => {
    myProposalListFunc()
    return () => {}
  }, [])

  const [myProposal, setmyProposal] = useState([])
  const [myProposalDetails, setmyProposalDetails] = useState()
  const [openAlert, setOpenAlert] = React.useState(false)
  let [proposalData, setProposalData] = useState()
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  let newObjectarray = []
  let proposalId = []
  const [allInfo, setAllInfo] = useState()
  const [allNewInfo, setAllNewInfo] = useState()

  const getProposalDetails = async (id) => {
    // console.log("calll")
    try {
      let proposalsss = await Proposal.proposals(id)
      let newObject = {
        id: id,
        name: proposalsss.variable_name.toString(),
        details: proposalsss.details.toString(),
        value: proposalsss.variable_value.toString(),
        address: proposalsss.proposer.toString(),
        status: proposalsss[11].toString(),
      }
      // proposalId.push(newObject)
      // setAllNewInfo(newObject)
      setProposalData(proposalsss)
      setmyProposalDetails(newObject)
      handleOpen()
    } catch (error) {
      console.log(error)
    }
  }

  console.log(allNewInfo, 'proposalsss')

  const myProposalListFunc = async () => {
    let result = await Proposal.userProposal()
    // console.log("result", result);
    myOwnProposalList(result)
    setmyProposal(result)
  }

  const myOwnProposalList = async (result) => {
    console.log(result)

    for (let i = 0; i < result.length; i++) {
      let proposalsss = await Proposal.proposals(result[i])
      let newObject = {
        id: result[i],
        name: proposalsss.variable_name,
        details: proposalsss.details,
        value: proposalsss.variable_value.toString(),
      }
      newObjectarray.push(newObject)
    }
    setAllInfo(newObjectarray)
  }

  // console.log("proposalalala", allInfo);

  const copyHash = (val) => {
    console.log('side')
    navigator.clipboard.writeText(val)
    setOpenAlert(true)
  }

  const shortenAccountId = (fullStr) => {
    const strLen = 40
    const separator = '...'

    if (fullStr?.length <= strLen) return fullStr

    const sepLen = separator.length
    const charsToShow = strLen - sepLen
    const frontChars = Math.ceil(charsToShow / 3)
    const backChars = Math.floor(charsToShow / 3)

    return (
      fullStr?.substr(0, frontChars) +
      separator +
      fullStr?.substr(fullStr?.length - backChars)
    )
  }

  return (
    <>
      <div>
        {/* <Button onClick={handleOpen}>Open modal</Button> */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <Typography className="header-text">Proposal details</Typography>
              {myProposalDetails ? (
                <>
                  <Card
                    className="section-card"
                    sx={{ width: 'auto !important' }}
                  >
                    <Grid
                      container
                      display={'flex'}
                      justifyContent={'space-between'}
                      py={2}
                    >
                      <Grid item xs={12} lg={4}>
                        Proposer address
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        lg={8}
                        sx={{ overflowWrap: 'anywhere' }}
                      >
                        {myProposalDetails.address}
                      </Grid>
                      <Divider />
                    </Grid>

                    <Grid
                      container
                      display={'flex'}
                      justifyContent={'space-between'}
                      py={2}
                    >
                      <Grid item xs={12} lg={4}>
                        Proposer ID
                      </Grid>
                      <Grid item xs={12} lg={8}>
                        {shortenAccountId(myProposalDetails.id)}
                        <ContentCopyIcon
                          style={{
                            cursor: 'pointer',
                            marginLeft: '1rem',
                          }}
                          onClick={() => copyHash(myProposalDetails.id)}
                        />

                        {openAlert ? (
                          <Snackbar
                            open={openAlert}
                            autoHideDuration={2000}
                            onClose={() => setOpenAlert(false)}
                          >
                            <Alert
                              onClose={() => setOpenAlert(false)}
                              severity="info"
                            >
                              Hash Copied
                            </Alert>
                          </Snackbar>
                        ) : null}
                      </Grid>
                      <Divider />
                    </Grid>

                    <Grid
                      container
                      display={'flex'}
                      justifyContent={'space-between'}
                      py={2}
                    >
                      <Grid item ml={3}>
                        Value{' '}
                      </Grid>
                      <Grid item>
                        {myProposalDetails.name === 'maxValidators'
                          ? myProposalDetails.value
                          : ethers.utils.formatEther(myProposalDetails.value)}
                      </Grid>
                      <Divider />
                    </Grid>

                    <Grid
                      container
                      display={'flex'}
                      justifyContent={'space-between'}
                      py={2}
                    >
                      <Grid item ml={3}>
                        Name{' '}
                      </Grid>
                      <Grid item>{myProposalDetails.name}</Grid>
                      <Divider />
                    </Grid>

                    <Grid
                      container
                      display={'flex'}
                      justifyContent={'space-between'}
                      py={2}
                    >
                      <Grid item ml={3}>
                        Status{' '}
                      </Grid>
                      <Grid item>
                        {myProposalDetails.status === true ? 'True' : 'False'}
                      </Grid>
                      <Divider />
                    </Grid>
                  </Card>
                </>
              ) : (
                <>
                  <Typography sx={{ textAlign: 'center', mt: 5 }}>
                    No data found
                  </Typography>{' '}
                </>
              )}
            </Box>
          </Fade>
        </Modal>
      </div>

      <div
        className="stack_modal"
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '8px',
          marginTop: '24px',
        }}
      >
        <Card className="section-card" item>
          <Box sx={{ flexFlow: 1, width: '100%' }}>
            <Typography className="header-text">My proposal list</Typography>
            {/* <div style={{ maxHeight: "335px",minHeight:'200px', overflow: "scroll" }}>
              {myProposal.length > 0 ? (
                myProposal.map((val, key) => {
                  return (
                    <>
                      <Grid container sx={{ display: "flex" }}>
                        <Grid item xs={8}>
                          <div style={{display:"flex",justifyContent:"space-evenly",alignItems:"center"}}>
                            <Typography
                              sx={{
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                              }}
                              pt={1}
                            >
                              {val}{" "}
                            </Typography>
                            <span style={{alignItems:"center",display:"flex",marginTop:"0.1rem"}}>
                              <ContentCopyIcon
                                style={{
                                  marginLeft: "0.5rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => copyHash(val)}
                              />
                            </span>
                          </div>
                        </Grid>
                        {openAlert ? (
                          <Snackbar
                            open={openAlert}
                            autoHideDuration={2000}
                            onClose={() => setOpenAlert(false)}
                          >
                            <Alert
                              onClose={() => setOpenAlert(false)}
                              severity="info"
                            >
                              Hash Copied
                            </Alert>
                          </Snackbar>
                        ) : null}
                        <Grid
                          item
                          xs={3}
                          sx={{ display: "flex", justifyContent: "end" }}
                        >
                          <Button
                            variant="outlined"
                            onClick={() => getProposalDetails(val)}
                          >
                            Info
                          </Button>
                        </Grid>
                      </Grid>
                      <Divider />
                    </>
                  );
                })
              ) : (
                <>
                  <Typography sx={{ textAlign: "center", m: 2 }}>
                    No data found
                  </Typography>{" "}
                </>
              )}
            </div> */}

            {allInfo !== undefined ? (
              <Grid container>
                <TableContainer component={Paper} className="table-container">
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow className="heading_table">
                        {columns.map((column) => (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ top: 57, minWidth: column.minWidth }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {allInfo ? (
                        allInfo.map((item, index) => {
                          return (
                            <TableRow
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  borderColor: '#8997B1',
                                },
                              }}
                            >
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{item.name}</TableCell>
                              <TableCell>
                                {item.value < 51
                                  ? item.value
                                  : ethers.utils.formatEther(item.value)}
                              </TableCell>
                              <TableCell>{item.details}</TableCell>
                              <TableCell>
                                <Button
                                  variant="outlined"
                                  onClick={() => getProposalDetails(item.id)}
                                >
                                  Info
                                </Button>
                              </TableCell>
                            </TableRow>
                          )
                        })
                      ) : (
                        <div style={{ textAlign: 'center', margin: '15%' }}>
                          <Typography variant="h4">
                            No Transaction Found
                          </Typography>
                        </div>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            ) : (
              <>
                <div className="voting_loader">
                  <Box>
                    <CircularProgress />
                  </Box>
                </div>
              </>
            )}

            {/* <Grid >
              <Typography variant="h4" pt={3} pb={2} textAlign={"center"}>
                Proposal details
              </Typography>
              {myProposalDetails ? (
                <>
                  <Card
                    sx={{
                      paddingLeft: "1rem",
                      paddingRight: "1rem",
                      boxShadow: 3,
                      backgroundColor:'#F8FAFD'
                    }}
                  >
                    <Grid
                      container
                      display={"flex"}
                      justifyContent={"space-between"}
                      py={2}
                    >
                      <Grid item ml={3}>
                        Proposer address
                      </Grid>
                      <Grid item>{myProposalDetails.proposer}</Grid>
                      <Divider />
                    </Grid>

                    <Grid
                      container
                      display={"flex"}
                      justifyContent={"space-between"}
                      py={2}
                    >
                      <Grid item ml={3}>
                        Value{" "}
                      </Grid>
                      <Grid item>
                      {myProposalDetails.variable_name ==='MaxValidators'?myProposalDetails.variable_value.toString(): myProposalDetails.variable_value.toString() /
                            1000000000000000000}

                      </Grid>
                      <Divider />
                    </Grid>

                    <Grid
                      container
                      display={"flex"}
                      justifyContent={"space-between"}
                      py={2}
                    >
                      <Grid item ml={3}>
                        Name{" "}
                      </Grid>
                      <Grid item>{myProposalDetails.variable_name}</Grid>
                      <Divider />
                    </Grid>

                    <Grid
                      container
                      display={"flex"}
                      justifyContent={"space-between"}
                      py={2}
                    >
                      <Grid item ml={3}>
                        Status{" "}
                      </Grid>
                      <Grid item>
                        {myProposalDetails[11] === true ? "True" : "False"}
                      </Grid>
                      <Divider />
                    </Grid>
                  </Card>
                </>
              ) : (
                <>
                  <Typography sx={{ textAlign: "center", mt: 5 }}>
                    No data found
                  </Typography>{" "}
                </>
              )}
            </Grid> */}
          </Box>
        </Card>
      </div>
    </>
  )
}
